import {useFormContext, Controller} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyagePlaceDeliveryField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  return (
    <Controller
      name={
        `boarding.voyages.${index}.placeDelivery` as `boarding.voyages.0.placeDelivery`
      }
      control={control}
      render={({field: {onChange, value}}) => (
        <ProcessTextField
          name={`boarding.voyages.${index}.placeDelivery`}
          placeholder="Local de entrega"
          value={value ?? ""}
          onChange={onChange}
          size="small"
          fullWidth
          label="Local de entrega"
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyagePlaceDeliveryField;
